<template>
    <v-footer
        v-show="visible"
        v-intersect="onIntersect"
        :color="footerColor"
        :theme="dark ? 'dark' : 'light'"
        class="footer flex-column flex-md-row flex-0-0"
        style="z-index: 1006"
    >
        <social-icons v-if="socialLinks.length" />
        <footer-menu
            v-if="
                footerMenu.length &&
                $breakpoint.mdAndUp &&
                !['authorization', 'b2b-auth', 'restore-password'].includes($route.name as string)
            "
        />
        <div class="footer-text ml-md-auto text-caption d-flex align-center flex-column flex-md-row">
            <div v-if="mailChimpLink" class="mx-8">
                <mail-chimp-form :mail-chimp-link="mailChimpLink" />
            </div>
            <span v-html="$t('copyright')" /><span v-if="!hideAppVersion">&nbsp;v{{ version }}</span>
        </div>
    </v-footer>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SocialIcons from '~/components/snippets/SocialIcons.vue'
    import FooterMenu from '~src/components/snippets/FooterMenu.vue'
    import {EventBus, FOOTER_INTERSECT_EVENT, FULL_SCREEN_MODE} from '@/utils/event-bus'
    import MailChimpForm from '@/components/MailChimpForm.vue'

    @Component({
        components: {
            MailChimpForm,
            SocialIcons,
            FooterMenu,
        },
    })
    export class FooterBar extends Vue {
        @Prop({default: false, type: Boolean}) dark
        @Prop({default: '', type: String}) footerColor

        visible = true

        mounted() {
            EventBus.$on(FULL_SCREEN_MODE, this.toggle)
        }

        beforeUnmount() {
            EventBus.$off(FULL_SCREEN_MODE, this.toggle)
        }

        toggle(fullScreenMode) {
            this.visible = !fullScreenMode
        }

        onIntersect(isIntersecting) {
            EventBus.$emit(FOOTER_INTERSECT_EVENT, isIntersecting)
        }

        get version() {
            return this.$conf.public.version
        }

        get mailChimpLink() {
            return this.$conf.public.mailChimpLink
        }

        get socialLinks() {
            return cmsStore.layoutSettings.socialLinks
        }

        get footerMenu() {
            return cmsStore.layoutSettings.footerMenu
        }

        get hideAppVersion() {
            return this.$conf.public.hideAppVersion
        }
    }

    export default FooterBar
</script>
